//NOTE autogenerated by export script
export {ArticleAPIService as Article} from './articleAPI.service'
export {ContactAPIService as Contact} from './contactAPI.service'
export {CountryAPIService as Country} from './countryAPI.service'
export {CustomerAPIService as Customer} from './customerAPI.service'
export {InvoiceAPIService as Invoice} from './invoiceAPI.service'
export {SchriftverkehrAPIService as Schriftverkehr} from './schriftverkehrAPI.service'
export {WarenpositionenAPIService as Warenpositionen} from './warenpositionenAPI.service'
export {BASE_PATH} from '../variables'
export {ApiModule} from '../api.module'
export {AllServices as All} from './allService'